import {getCountryCode} from '../CountryRestriction/CountryRestrictionUtility';
import {initForContainer} from './SocialShareUtility';
import {closeSearchOverlay} from '../Navigation/NavSearchFormUtility';
import {closeResponsiveMenu} from '../Navigation/MobileNavUtility';
import * as $ from 'jquery';

export class ContactAndSocialShareFlyOutController {
  protected readonly autoCloseAfter = 5000; // ms
  protected readonly autoCloseAfterOffset = 200; // ms
  protected readonly autoReopenAfter = 24 * 60 * 60 * 1000; // ms ( => 24h)
  protected readonly showSurveyAgainAfter = 60 * 60 * 1000; // ms ( => 1h)

  constructor() {
    let $linkElement = $('.js-contact-ajax-link');
    if ($linkElement.length) {
      let url = $linkElement.data('contactAjaxLink') || '';
      if (url && !$linkElement.hasClass('js-no-contact')) {
        url = url.replace('REPLACE_ME_REPLACE_ME', getCountryCode());
        $.getJSON(url)
          .done((data: { flyOutHtml: string } | any) => {
            let htmlTag = document.querySelector('html');
            if (htmlTag !== null && !htmlTag.classList.contains('extranet')) {
              if (typeof data.flyOutHtml === 'string' && data.flyOutHtml.trim()) {
                this.useHtml(data.flyOutHtml);
              } else {
                this.gotError(false);
              }
            }
            this.addSpecialClickWatcherForCn();
            this.addContactClickWatcher();
            const $flyoutText = $('.js-contactOverlay').find('.js-flyoutText').clone();
            $('.js-mobileNavInformation').append($flyoutText);
            if ($('.js-nothing-found-component_contact').length) {
              this.copyContactIntoFDSTErrorMessage($flyoutText);
            }
          })
          .fail((error) => {
            this.gotError(error);
          });
      }
    }

    // setTimeout(
    //   () => {
    //     if (localStorage) {
    //       let item = '0';
    //       if (localStorage) {
    //         item = localStorage.getItem('hide-survey') || '0';
    //       }
    //       if (item === null || item === '0') {
    //         this.showSurvey();
    //       } else {
    //         if (parseInt(item, 10) < Date.now() - this.showSurveyAgainAfter) {
    //           this.showSurvey();
    //         }
    //       }
    //     }
    //   },
    //   500,
    // );
    //
    // $('.js-closeSurveyFlyout').on('click', () => {
    //   this.hideSurvey();
    // });
    //
    // $('.js-toggleSurveyFlyout').on('click', () => {
    //   this.toggleSurvey();
    // });
  }

  protected addSpecialClickWatcherForCn() {
    const bodyTag = document.querySelector('body');
    if (bodyTag !== null && bodyTag.classList.contains('country-cn') && $('.js-specialFlyoutCn').length) {
      const $shareFlyout = $('.js-shareOverlay');
      const $specialFlyoutButton = $shareFlyout.find('.js-share-wechat');
      $specialFlyoutButton.on('mouseenter', () => {
        $shareFlyout.find('.js-specialFlyoutCn').addClass('flyout__text--imageVisible');
      });
      $specialFlyoutButton.on('mouseleave', () => {
        $shareFlyout.find('.js-specialFlyoutCn').removeClass('flyout__text--imageVisible');
      });
    }
  }

  /**
   * add click watcher only used when contact button is located in header
   */
  protected addContactClickWatcher() {
    const $contactFlyout = $('.js-contactOverlay');
    const $contactFlyoutCloseButton = $contactFlyout.find('.js-flyout-icon-close');
    const $contactFlyoutOpenButton = $contactFlyout.find('.js-flyout-icon');
    if ($contactFlyoutCloseButton) {
      $contactFlyoutCloseButton.on('click', () => {
        $contactFlyout.removeClass('flyout--visibleResponsive');
      });
    }
    if ($contactFlyoutOpenButton) {
      $contactFlyoutOpenButton.on('click', () => {
        closeSearchOverlay();
        closeResponsiveMenu();
        $contactFlyout.addClass('flyout--visibleResponsive');

        $('.mm-page').one('click', () => {
          $contactFlyout.removeClass('flyout--visibleResponsive');
        });
      });
    }
  }

  /**
   * add duplicate of contact flyout text to nothing-found-message in FDST
   */
  protected copyContactIntoFDSTErrorMessage($flyoutText: JQuery): void {
    $('.js-nothing-found-component_contact').append($flyoutText);
  }

  protected useHtml(html: string): void {
    $(() => {
      this.addHtmlToPage(html);
      this.openAndAutoClose();
    });
  }

  protected gotError(error: false | any): void {
    this.showSocialIcons();
    if (error !== false) {
      console.error(error);
      throw new Error('AjaxError');
    }
  }

  protected openAndAutoClose() {
    let item = '0';
    if (localStorage) {
      item = localStorage.getItem('contact-ajax-auto-show') || '0';
    }
    if (parseInt(item, 10) < Date.now() - this.autoReopenAfter) {
      if (localStorage) {
        localStorage.setItem('contact-ajax-auto-show', Date.now().toString());
      }
      this.showContactInfo();
      setTimeout(
        () => {
          this.showSocialIcons();
        },
        this.autoCloseAfterOffset,
      );
      setTimeout(
        () => {
          closeResponsiveMenu();
          this.hideSocialIcons();
          setTimeout(
            () => {
              this.hideContactInfo();
            },
            this.autoCloseAfterOffset,
          );
        },
        this.autoCloseAfter,
      );
    }
  }

  protected addHtmlToPage(html: string) {
    const $body = $('body');
    $body.append(html);
    $body.addClass('body--showShareIcons');

    this.addContactClickListener();
    this.addShareClickListener();
  }

  protected showContactInfo() {
    $('.js-contactOverlay').addClass('flyout--visible');
  }

  protected showSocialIcons() {
    $('.js-shareOverlay').addClass('flyout--visible');
  }

  protected hideSocialIcons() {
    $('.js-shareOverlay').removeClass('flyout--visible');
  }

  protected hideContactInfo() {
    $('.js-contactOverlay').removeClass('flyout--visible');
  }

  protected addContactClickListener() {
    initForContainer($('.js-contactOverlay'));
  }

  protected addShareClickListener() {
    initForContainer($('.js-shareOverlay'));
  }

  // protected toggleSurvey() {
  //   if ($('.js-surveyOverlay').hasClass('flyout--visible')) {
  //     this.hideSurvey();
  //   } else {
  //     this.showSurvey();
  //   }
  // }
  //
  // protected showSurvey() {
  //   $('.js-surveyOverlay').addClass('flyout--visible');
  // }
  //
  // protected hideSurvey() {
  //   if (localStorage) {
  //     localStorage.setItem('hide-survey', Date.now().toString());
  //   }
  //   $('.js-surveyOverlay').removeClass('flyout--visible');
  // }
}

export function hideContactInfo() {
  $('.js-contactOverlay').removeClass('flyout--visibleResponsive');
}
